var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"baseBtnSetupPosition",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"baseBtnSetupPosition__text"},[_vm._v(_vm._s(_vm.btnText))]),_c('searchIcon',{staticClass:"baseBtnSetupPosition__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }